import { InjectionToken } from '@angular/core';
import { JobsPlacementsConfig } from '../interfaces/jobs-placements-config.interface';

export const JOB_PLACEMENTS_CONFIG_TOKEN = new InjectionToken<JobsPlacementsConfig>('Jobs & placements config');
